import { render, staticRenderFns } from "./Drag.vue?vue&type=template&id=45d510b4"
import script from "./Drag.vue?vue&type=script&lang=js"
export * from "./Drag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports